import { twJoin, getDefaultConfig, createTailwindMerge } from 'tailwind-merge';
/**
 * Combine CSS class names.
 *
 * This uses the implementation of `twJoin` from [`tailwind-merge`](https://www.npmjs.com/package/tailwind-merge).
 *
 * Note that it [does not support object argument](https://github.com/dcastil/tailwind-merge/blob/v2.2.2/docs/api-reference.md#twjoin).
 *
 * @example
 * classNames(
 *   'here are some default class names',
 *   onlyWhenThisIsTruthy && 'yep it is truthy',
 *   maybeUseTernaries ? 'yep' : 'nope
 * );
 * @param classes
 */
export const classNames = twJoin;
/**
 * Creates a tailwind merge function.
 */
export function createTwMerge({ prefix }) {
    return createTailwindMerge(() => {
        const defaultConfig = getDefaultConfig();
        return { ...defaultConfig, prefix };
    });
}
/**
 * `classNames()` that merges overlapping classes.
 * this is a custom `tailwind-merge` for PANWDS with `tw-` prefix.
 * It is intended for PANWDS internal use.
 *
 * For MFEs, please create your own using `createTwMerge()` if needed
 * If you are keeping your tailwind classes clean and not creating custom-stylable components,
 * you don't need to use the `tailwind-merge` functionality.
 *
 * Usage note:e
 * This should be used in module boundary component
 * (i.e. HTML nodes, or 3rd party component),
 * so that any overlapping class names are eliminated.
 */
export const twMerge = createTwMerge({ prefix: 'tw-' });
//# sourceMappingURL=classNames.js.map